import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "finance_hwc_statement_code_type",
      "id": "finance_hwc_statement_code_type"
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, _vm._l(_vm.codeTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "finance_hwc_statement_code_value",
      "id": "finance_hwc_statement_code_value",
      "allowClear": "",
      "maxLength": 100
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u7269\u6D41\u65B9\u5F0F"),
      "data-permission": "finance_hwc_statement_sm_code",
      "id": "finance_hwc_statement_sm_code",
      "show-tip": "",
      "placeholder": _vm.t('物流方式'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.product_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_code", $$v);
      },
      expression: "searchData.product_code"
    }
  }, _vm._l(_vm.logisticsList, function (item) {
    return _c('a-select-option', {
      key: item.sm_code
    }, [_vm._v(_vm._s(item.sm_name))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "data-permission": "finance_hwc_statement_warehouse_code",
      "id": "finance_hwc_statement_warehouse_code",
      "show-tip": "",
      "placeholder": _vm.t('仓库'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.regional_warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "regional_warehouse_code", $$v);
      },
      expression: "searchData.regional_warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5355\u636E\u7C7B\u578B"),
      "data-permission": "finance_hwc_statement_ds_code",
      "id": "finance_hwc_statement_ds_code",
      "show-tip": "",
      "placeholder": _vm.t('单据类型'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.business_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "business_type", $$v);
      },
      expression: "searchData.business_type"
    }
  }, _vm._l(_vm.dsCodeListEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u8BA2\u5355\u7C7B\u578B"),
      "id": "finance_hwc_statement_order_type",
      "show-tip": "",
      "placeholder": _vm.t('订单类型'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.order_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_type", $$v);
      },
      expression: "searchData.order_type"
    }
  }, _vm._l(_vm.orderTypeList, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "124px"
    },
    attrs: {
      "allow-clear": false,
      "data-permission": "finance_hwc_statement_time_type",
      "id": "finance_hwc_statement_time_type"
    },
    model: {
      value: _vm.searchData.time_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_field", $$v);
      },
      expression: "searchData.time_field"
    }
  }, _vm._l(_vm.timeTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "finance_hwc_statement_time_value",
      "id": "finance_hwc_statement_time_value",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "limit-range-day": 180,
      "format": "YYYY/MM/DD",
      "allow-clear": false
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "suffixIcon",
      "type": "calendar"
    },
    slot: "suffixIcon"
  })], 1), _c('a-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.t('时间跨度筛选最长支持180天。')))]), _c('div', [_c('a-icon', {
    staticClass: "ml-5 mt-10",
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "type": "question-circle"
    }
  })], 1)])], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "finance_hwc_statement_query",
      "data-permission": "finance_hwc_statement_search",
      "id": "finance_hwc_statement_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(" " + _vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_hwc_statement_reset",
      "data-permission": "finance_hwc_statement_reset",
      "id": "finance_hwc_statement_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'finance_hwc_statement_export',
      expression: "'finance_hwc_statement_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "finance_hwc_statement_export_all",
      "id": "finance_hwc_statement_export_all",
      "data-sign": "finance_hwc_statement_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "finance_hwc_statement_export_selected",
      "id": "finance_hwc_statement_export_selected",
      "data-sign": "finance_hwc_statement_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(" " + _vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "finance_hwc_statement_list",
      "is-filter-box": "",
      "columns": _vm.columns,
      "fixed-header": "",
      "useMouseTool": "",
      "name": "hwcStatementList",
      "data-source": _vm.dataList,
      "row-selection": _vm.rowSelection,
      "row-key": "order_number"
    },
    scopedSlots: _vm._u([{
      key: "total_amount_list",
      fn: function (ref) {
        var record = ref.record;
        return [_c('text-ellipses', _vm._l(record.total_amount_list || [], function (item, index) {
          return _c('div', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.amount,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        }), 0)];
      }
    }, {
      key: "regional_warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record['regional_warehouse_code'] ? _c('span', [_vm._v(_vm._s(record['regional_warehouse_code']))]) : _vm._e(), record['regional_warehouse_name'] ? _c('span', [_vm._v("[" + _vm._s(record['regional_warehouse_name']) + "]")]) : _vm._e()]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('a', {
          staticClass: "mr-10",
          attrs: {
            "data-sign": "finance_hwc_statement_detail",
            "data-permission": "finance_hwc_statement_info",
            "id": "finance_hwc_statement_info",
            "fbu-analyse-name": $t("\u8BE6\u60C5")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('详情')))])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "hwcStatementList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size,
      "orderListEsPoint": _vm.orderListEsPoint
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('detail', {
    attrs: {
      "rowData": _vm.rowData,
      "visible": _vm.detailsVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.detailsVisible = $event;
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };